var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePasswordHideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#440099"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3213 17.3213C17.1501 17.505 16.9436 17.6524 16.7142 17.7546C16.4848 17.8568 16.2372 17.9118 15.9861 17.9162C15.735 17.9206 15.4855 17.8745 15.2527 17.7804C15.0198 17.6863 14.8083 17.5463 14.6307 17.3688C14.4531 17.1912 14.3131 16.9796 14.2191 16.7468C14.125 16.5139 14.0788 16.2645 14.0832 16.0134C14.0877 15.7623 14.1426 15.5146 14.2448 15.2852C14.3471 15.0558 14.4944 14.8494 14.6782 14.6782M19.7026 19.7026C18.637 20.5148 17.3394 20.9648 15.9997 20.9867C11.6361 20.9867 9.14258 15.9997 9.14258 15.9997C9.91799 14.5547 10.9935 13.2922 12.2969 12.2969L19.7026 19.7026ZM14.6906 11.1623C15.1197 11.0619 15.559 11.0117 15.9997 11.0127C20.3634 11.0127 22.8569 15.9997 22.8569 15.9997C22.4785 16.7076 22.0272 17.3741 21.5104 17.9883L14.6906 11.1623Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14282 9.14307L22.8571 22.8574",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePasswordHideIcon);
export default __webpack_public_path__ + "static/media/profilePasswordHideIcon.185e4f70397e4214cde3ac20ad5cd5f7.svg";
export { ForwardRef as ReactComponent };